import { Box, type BoxProps } from '@mui/material'
import { grey } from '@mui/material/colors'
import { InfoOutlined } from '@mui/icons-material'
import { styled } from '@mui/material/styles'
import { type ComponentType } from 'react'

export const SMALL_BREAKPOINT = 700

export const FiltersWrapper: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	marginBottom: theme.spacing( 2 ),
	padding: `${theme.spacing( 1 )} 0 ${theme.spacing( 2 )} 0`,
	borderBottom: `1px solid ${grey.A400}`,
} ) )

export const PillWrapper: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	display: 'flex',
	flexWrap: 'wrap',
	gap: theme.spacing( 1 ),

	[ theme.breakpoints.down( SMALL_BREAKPOINT ) ]: {
		marginBottom: theme.spacing( 1 ),
	},
} ) )

export const TopWrapper: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	display: 'flex',
	flex: 1,
	marginBottom: theme.spacing( 1 ),

	[ theme.breakpoints.down( SMALL_BREAKPOINT ) ]: {
		flexDirection: 'column',
	},
} ) )

export const BottomWrapper: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	display: 'flex',
	flex: 1,
	justifyContent: 'space-between',

	[ theme.breakpoints.down( SMALL_BREAKPOINT ) ]: {
		flexDirection: 'column',
	},
} ) )

export const ItemInfoIcon: ComponentType = styled( InfoOutlined )( ( { theme } ) => ( {
	fontSize: theme.typography.caption.fontSize,
	color: theme.palette.text.secondary,
} ) )

export const FilterButtonsWrapper: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	marginLeft: theme.spacing( 1 ),

	[ theme.breakpoints.down( SMALL_BREAKPOINT ) ]: {
		marginLeft: 0,
		marginTop: theme.spacing( 1 ),
	},
} ) )

export const ActionsWrapper: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing( 1 ),
} ) )
